import type { Component } from 'vue';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';

/** 旧 Element UI 图标名 -> Element Plus 组件名（与 iconFrom 保持一致） */
export const crmebIconNameAlias: Record<string, string> = {
  's-tools': 'Setting',
  'platform-eleme': 'Eleme',
  's-goods': 'Goods',
  's-order': 'List',
  's-platform': 'Platform',
  's-fold': 'Fold',
  's-unfold': 'Expand',
  's-operation': 'Operation',
  's-promotion': 'Promotion',
  's-home': 'HomeFilled',
  's-release': 'Upload',
  's-ticket': 'Ticket',
  's-management': 'Management',
  's-open': 'Open',
  's-shop': 'Shop',
  's-marketing': 'Promotion',
  's-flag': 'Flag',
  's-comment': 'Comment',
  's-finance': 'CreditCard',
  's-claim': 'Document',
  's-custom': 'User',
  's-opportunity': 'Opportunity',
  's-data': 'DataBoard',
  's-check': 'CircleCheck',
  's-grid': 'Grid',
  's-cooperation': 'Connection',
  's-help': 'Help',
  'suitcase-1': 'Briefcase',
  'notebook-1': 'Notebook',
  'notebook-2': 'Notebook',
  'video-pause': 'VideoPause',
  'video-play': 'VideoPlay',
  'refresh-right': 'RefreshRight',
  'refresh-left': 'RefreshLeft',
  'c-scale-to-original': 'ScaleToOriginal',
  'edit-outline': 'Edit',
  'document-add': 'DocumentAdd',
  'document-remove': 'DocumentRemove',
  'document-delete': 'DocumentDelete',
  'document-copy': 'DocumentCopy',
  'document-checked': 'DocumentChecked',
  'folder-add': 'FolderAdd',
  'folder-remove': 'FolderRemove',
  'folder-delete': 'FolderDelete',
  'folder-checked': 'FolderChecked',
  'picture-outline': 'Picture',
  'picture-outline-round': 'PictureRounded',
  'camera-solid': 'CameraFilled',
  'video-camera-solid': 'VideoCameraFilled',
  'message-solid': 'Message',
  'user-solid': 'UserFilled',
  'phone-outline': 'Phone',
  'more-outline': 'More',
  'star-on': 'StarFilled',
  'star-off': 'Star',
  'warning-outline': 'Warning',
  'delete-solid': 'DeleteFilled',
  'circle-plus-outline': 'CirclePlus',
  'remove-outline': 'Remove',
  'd-caret': 'DCaret',
  'upload2': 'UploadFilled',
  'bangzhu': 'Help',
  'close-notification': 'Close',
  'medal-1': 'Medal',
  'trophy-1': 'TrophyBase',
  'watch-1': 'Watch',
  'sunrise-1': 'Sunrise',
  'dish-1': 'Dish',
  'goblet-square': 'GobletSquare',
  'goblet-square-full': 'GobletSquareFull',
  'ice-cream-square': 'IceCreamSquare',
  'ice-cream-round': 'IceCreamRound',
  'shopping-cart-1': 'ShoppingCart',
  'shopping-cart-2': 'ShoppingCart',
  'shopping-bag-1': 'ShoppingBag',
  'shopping-bag-2': 'ShoppingBag',
  'location-outline': 'Location',
  'add-location': 'AddLocation',
  'delete-location': 'DeleteLocation',
  'map-location': 'MapLocation',
  'turn-off-microphone': 'Mute',
  'full-screen': 'FullScreen',
  'copy-document': 'CopyDocument',
  medal: 'GoldMedal',
  'light-rain': 'Drizzling',
  'heavy-rain': 'Pouring',
  'partly-cloudy': 'PartlyCloudy',
  'cloudy-and-sunny': 'MostlyCloudy',
  'moon-night': 'MoonNight',
  'dish-dot': 'DishDot',
  'knife-fork': 'KnifeFork',
  'ice-tea': 'IceTea',
  'potato-strips': 'Fries',
  success: 'CircleCheck',
  failed: 'CircleClose',
  rank: 'Rank',
  reading: 'ReadingLamp',
  suitcase: 'SuitcaseLine',
  /** vue-element-admin 遗留名，TiTa 扩展菜单曾误用 */
  dashboard: 'Odometer',
  'tree-table': 'Collection',
  house: 'House',
  link: 'Link',
};

function toPascalCase(name: string): string {
  return name
    .split('-')
    .map((p) => p.charAt(0).toUpperCase() + p.slice(1).toLowerCase())
    .join('');
}

/** 去掉 el-icon- 前缀，得到 EB 菜单里的图标名 */
export function normalizeCrmebIconName(icon?: string): string {
  if (!icon) return '';
  const raw = icon.trim();
  if (!raw) return '';
  if (raw.startsWith('el-icon-')) return raw.slice('el-icon-'.length);
  return raw;
}

/** 是否为 iconfont 类名（非 Element 图标） */
export function getCrmebIconfontClass(icon?: string): string | null {
  if (!icon) return null;
  const raw = icon.trim();
  if (!raw) return null;
  if (raw.includes('iconfont') || raw.startsWith('icon-')) {
    return raw.replace(/\s*iconfont\s*/g, ' ').trim();
  }
  return null;
}

/** EB 菜单 icon 字段 -> Element Plus 图标组件 */
export function resolveCrmebIconComponent(icon?: string): Component | null {
  const name = normalizeCrmebIconName(icon);
  if (!name || getCrmebIconfontClass(icon)) return null;
  const key = crmebIconNameAlias[name] ?? toPascalCase(name);
  return (ElementPlusIconsVue as Record<string, Component>)[key] ?? null;
}
